<template>
  <div class="job-sent-step">
    <div class="step">
      <div class="circle circle-active">
        <span class="label">Job Details</span>
      </div>

      <div class="step-check">
        <div class="line line-active"></div>
        <div
          class="circle"
          :class="jobStep == 1 || jobStep == 2 ? 'circle-active' : ''"
        >
          <span class="label">Apply</span>
        </div>
      </div>

      <div class="step-check">
        <div class="line line-active"></div>
        <div class="circle" :class="jobStep == 2 ? 'circle-active' : ''">
          <span class="label">Go!</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobShareStep',

  props: {
    step: {
      type: Number,
      required: true,
    },
  },

  computed: {
    jobStep: function () {
      return this.step
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';
.job-sent-step {
  padding-bottom: 5rem;

  @include sp {
    padding-bottom: 3rem;
  }

  .step {
    align-items: center;
    display: flex;
    justify-content: center;

    .step-check {
      display: contents;
    }

    .circle,
    .circle-icon {
      align-items: center;
      background: none;
      border: 1px solid $blue-primary;
      border-radius: 100rem;
      display: flex;
      height: 60px;
      justify-content: center;
      width: 60px;
      .label {
        color: $blue-primary;
        font-size: 11px;
        font-weight: 500;
        text-align: center;
      }
    }
    .circle-active {
      background: $blue-primary;
      .label {
        color: $white;
      }
    }
    .line {
      border-top: 1px dashed $blue-primary;
      margin: 0 6px;
      width: 40px;
    }
    .line-active {
      border-top: solid $blue-primary;
    }
    .circle-icon {
      background: none;
      i {
        color: $blue-primary;
        font-size: 24px;
      }
    }
  }
}
</style>
